import { Pipe, PipeTransform } from '@angular/core';
import { WishlistItem } from '@df/session/api/wishlist/wishlist-item';

@Pipe({
    name: 'wishlistSort',
    standalone: true
})
export class WishlistSortPipe implements PipeTransform {
    transform(items: WishlistItem[]): WishlistItem[] {
        return wishlistSort(items);
    }
}

export function wishlistSort(items: WishlistItem[]): WishlistItem[] {
    const sortByDate = (items: WishlistItem[]) =>
        items.sort((a, b) => {
            return new Date(b.data?.added_at).getTime() - new Date(a.data?.added_at).getTime();
        });

    const outOfStockItems = sortByDate(items.filter(item => !item.product?.inStock));
    const inStockItems = sortByDate(items.filter(item => item.product?.inStock));

    return [...inStockItems, ...outOfStockItems];
}
